import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import * as Cookies from "js-cookie";

import { AdminLayout } from "../Layout/Layout";
import { AdminProfile } from "./AdminProfile/AdminProfile";
import { AdminDistributors } from "./AdminDistributors/AdminDistributors";
import { AdminDistributorEdit } from "./AdminDistributorEdit/AdminDistributorEdit";
import { AdminAccounts } from "./AdminAccounts/AdminAccounts";
import { AdminAccountsEdit } from "./AdminAccountsEdit/AdminAccountsEdit";
import { OnAccountUpdated } from "../Subscriptions/OnAccountUpdated/OnAccountUpdated";
import { AdminDistributorNew } from "./AdminDistributorNew/AdminDistributorNew";
import { AdminAccountsNew } from "./AdminAccountsNew/AdminAccountsNew";
import { AdminUsers } from "./AdminUsers/AdminUsers";
import { AdminUsersNew } from "./AdminUsersNew/AdminUsersNew";
import { OnSSOUserInvitedToAccount } from "../Subscriptions/onSSOUserInvitedToAccount/onSSOUserInvitedToAccount";
import { AccountSearchProvider } from "../../Context/AccountSearchContext/AccountSearchContext";
import { DistributorSearchProvider } from "../../Context/DistributorSearchContext/DistributorSearchContext";
import { UsersSearchProvider } from "../../Context/UsersSearchContext/UsersSearchContext";
import { AdminManageUser } from "./AdminManageUser/AdminManageUser";
import { AdminAdminstration } from "./AdminAdminstration/AdminAdminstration";
import { AdminCountryEdit } from "./AdminCountryEdit/AdminCountryEdit";
import { AdminCountryNew } from "./AdminCountryNew/AdminCountryNew";
import { AdminActiveAdministrationTabProvider } from "../../Context/AdminActiveAdministrationTabContext/AdminActiveAdministrationTabContext";
import { useQuery } from "@apollo/client";
import loggedIn from "../../GraphQL/Query/loggedIn";

export const Admin = () => {
  const adminRole = Cookies.get("access_level");
  const { data, loading } = useQuery(loggedIn, {
    fetchPolicy: "network-only",
  });

  if (loading) {
    return null;
  }

  if (!data?.loggedIn) {
    return <Redirect to="/login" />;
  }
  if (adminRole === "CUSTOMER") {
    return <Redirect to="/sso" />;
  } else {
    return (
      <div className="Admin">
        <AdminLayout role={adminRole}>
          <AccountSearchProvider>
            <DistributorSearchProvider>
              <UsersSearchProvider>
                <AdminActiveAdministrationTabProvider>
                  <Switch>
                    <Route
                      path="/admin/profile"
                      exact
                      component={AdminProfile}
                    />
                    {adminRole === "SUPERADMIN" && (
                      <Route
                        path="/admin/distributors"
                        exact
                        component={AdminDistributors}
                      />
                    )}
                    {adminRole === "SUPERADMIN" && (
                      <Route
                        path="/admin/distributors/new"
                        exact
                        component={AdminDistributorNew}
                      />
                    )}
                    {adminRole === "SUPERADMIN" && (
                      <Route
                        path="/admin/distributors/:id/edit"
                        exact
                        component={AdminDistributorEdit}
                      />
                    )}
                    <Route
                      path="/admin/accounts"
                      exact
                      component={AdminAccounts}
                    />
                    <Route
                      path="/admin/accounts/new"
                      exact
                      component={AdminAccountsNew}
                    />
                    <Route
                      path="/admin/accounts/:id/new"
                      exact
                      component={AdminAccountsNew}
                    />
                    <Route
                      path="/admin/accounts/:id/edit"
                      exact
                      component={AdminAccountsEdit}
                    />
                    <Route path="/admin/users" exact component={AdminUsers} />
                    <Route
                      path="/admin/users/:id/manage"
                      exact
                      component={AdminManageUser}
                    />
                    <Route
                      path="/admin/administration"
                      exact
                      component={AdminAdminstration}
                    />
                    <Route
                      path="/admin/administration/country/:id"
                      exact
                      component={AdminCountryEdit}
                    />
                    <Route
                      path="/admin/administration/country"
                      exact
                      component={AdminCountryNew}
                    />
                    <Route
                      path="/admin/accounts/:id/invite-user"
                      exact
                      component={AdminUsersNew}
                    />
                    <Route
                      path="/admin/distributors/:id/invite-user"
                      exact
                      component={AdminUsersNew}
                    />
                    <Route
                      path="/admin/users/invite-user"
                      exact
                      component={AdminUsersNew}
                    />
                    <Route render={() => <Redirect to="/admin/profile" />} />
                  </Switch>
                </AdminActiveAdministrationTabProvider>
              </UsersSearchProvider>
            </DistributorSearchProvider>
          </AccountSearchProvider>
        </AdminLayout>
        <OnAccountUpdated />
        <OnSSOUserInvitedToAccount />
      </div>
    );
  }
};
